// 1. IMPORTS
import React from "react";
import { Form, Input } from "antd";
import PaymentMethodConfigPanel from "./PaymentMethodConfigPanel";
import PaymentMethodQrCodeField from "./PaymentMethodQrCodeField";
import { PAYMENT_METHOD_TYPE } from "constants/paymentMethod";
import { VIETNAM_PHONE_PATTERN } from "helper/UtilsFunctionsValidation";

// 2. COMPONENT
function PaymentMethodConfigPanelGtelpay(props) {
  // 8. MAIN JSX
  return (
    <PaymentMethodConfigPanel {...props} paymentMethodType={PAYMENT_METHOD_TYPE.GTELPAY}>
      <Form.Item label="Tên tài khoản" name="paymentMethodReceiverName"
        rules={[{ required: true, message: "Vui lòng nhập tên tài khoản" }]}>
        <Input />
      </Form.Item>
      <Form.Item label="Số điện thoại" name="paymentMethodIdentityNumber"
        rules={[
          { required: true, message: "Vui lòng nhập số điện thoại" },
          { pattern: VIETNAM_PHONE_PATTERN, message: "Số điện thoại không hợp lệ (phải là số VN, 10 chữ số)" },
        ]}>
        <Input />
      </Form.Item>
      <PaymentMethodQrCodeField required />
    </PaymentMethodConfigPanel>
  );
}

// 9. EXPORTS
export default PaymentMethodConfigPanelGtelpay;